import { compose, withState, withHandlers, mapProps } from 'recompose';
import omit from 'ramda/src/omit';
import { maintenanceModeRef } from '../../config.js';

const withMaintenanceMode = compose(
  withState('maintenanceMode', 'setMaintenanceMode', false),
  withHandlers({
    syncMaintenanceMode: props => () => {
      maintenanceModeRef.on('value', snap => {
        props.setMaintenanceMode(snap.val() || false);
      });
    }
  }),
  mapProps(omit(['setMaintenanceMode']))
);

export default withMaintenanceMode;



// WEBPACK FOOTER //
// ./src/components/hocs/withMaintenanceMode.js